<template>
  <div class="subsidiaryInformation-form section grid-view">
    <div class="main-content">
      <div class="operations" style="margin-bottom: 5px">
        <div class="triggers">
          <div>
            <el-button
              no="new"
              :disabled="!isEdit"
              type="primary"
              @click="add()"
            >{{ $t('common.btn.new') }}</el-button>
            <el-button
              no="delete"
              :disabled="!isEdit"
              size="mini"
              type="danger"
              @click="remove"
            >{{ $t('common.btn.delete') }}</el-button>
          </div>
        </div>
      </div>
      <div class="grid-wrapper">
        <cargo-ag-grid
          :key="1"
          :grid-params.sync="girdParams"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="finalRowData"
        />
      </div>
    </div>
    <!--查询合作伙伴-->
    <query-company-dialog
      v-if="queryCompanyDialog.visible"
      :visible.sync="queryCompanyDialog.visible"
      :is-query-parent-company="false"
      :title="$t('CargoMsg.Cargo_Add')"
      @enterEvent="addSubsidiaryCompany"
    />
  </div>
</template>

<script>

import { getGridSelected } from '@/utils/agGrid'
import queryCompanyDialog from '@/views/cargo/v0/Information/components/partner/queryCompanyDialog'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import * as PartnerServiceItem from '@/class/cargo/model/parameters/PartnerServiceItem'
import { loadCompanyRelated } from '@/api/company'

export default {
  name: 'SubsidiaryInformation',
  components: { queryCompanyDialog },
  props: {
    action: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      form: {},
      girdParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        }
      },
      rowData: [],
      columnDefs: [
        {
          headerName: '', width: 60, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ChineseName'),
          field: 'chineseName',
          colId: 'chineseName',
          width: 200
        },
        {
          headerName: this.$t('CargoMsg.Cargo_EnglishName'),
          field: 'englishName',
          colId: 'englishName',
          width: 200
        },
        {
          headerName: this.$t('CargoMsg.Cargo_abbreviation'),
          field: 'shortName',
          colId: 'shortName',
          width: 200
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Code'),
          field: 'cnShortName',
          colId: 'cnShortName',
          width: 100
        },
        {
          headerName: this.$t('CargoMsg.Cargo_BranchCompany'),
          field: 'branchId',
          colId: 'branchId',
          width: 100,
          cellRenderer: (params) => {
            if (params.value === 1) {
              return 'HQ'
            }
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office, 'officeId', params.value, 'code')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_CustomerType'),
          field: 'customer',
          colId: 'customer',
          width: 100,
          valueFormatter: (params) => {
            return this.companyTypeLabelFunc(params.data)
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return this.companyTypeLabelFunc(params.data)
          }
        }
      ],
      queryCompanyDialog: {
        visible: false
      }
    }
  },
  computed: {
    gridApi() {
      return this.girdParams.api
    },
    readonly() {
      return !this.action || this.action === 'look'
    },
    isEdit() {
      return this.action === 'new' || this.action === 'edit'
    },
    finalRowData() {
      return this.rowData.filter(p => !p.deleted)
    },
    isZh() {
      return this.$store.getters.language === 'zh'
    }
  },
  created() {
  },
  methods: {
    async onShow(row, isRefresh) {
      if (!isRefresh && this.isEdit) return
      this.form = row
      if (!this.form.hasOwnProperty('addedSubsidiaryCompanyKeys')) {
        this.form.addedSubsidiaryCompanyKeys = []
      }
      if (!this.form.hasOwnProperty('deletedSubsidiaryCompanyKeys')) {
        this.form.deletedSubsidiaryCompanyKeys = []
      }
      if (this.readonly) {
        const data = await loadCompanyRelated({ companyUuid: this.form.uuid, subsidiaryCompany: true }).then(res => res.data)
        this.form.subsidiaryCompanyList = data ? data.subsidiaryCompanyList : row.subsidiaryCompanyList
      }
      this.rowData = this.form.subsidiaryCompanyList || []
    },
    add() {
      this.queryCompanyDialog.visible = true
    },
    remove() {
      const rows = getGridSelected(this.gridOptions)
      if (!rows || rows.length === 0) {
        this.$message.warning(this.$t('Partners.deleteSubsidiaryTips'))
        return
      }
      this.$confirm(this.$t('Partners.deleteSubsidiaryConfirm'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        for (const row of rows) {
          const index = this.rowData.findIndex(p => p.uuid === row.uuid)
          if (index >= 0) {
            this.rowData.splice(index, 1)
          }
          // 添加到删除的集合中
          const delIndex = this.form.deletedSubsidiaryCompanyKeys.findIndex(p => p === row.uuid)
          if (delIndex < 0) {
            this.form.deletedSubsidiaryCompanyKeys.push(row.uuid)
          }
          // 从新的集合中删除
          const addIndex = this.form.addedSubsidiaryCompanyKeys.findIndex(p => p === row.uuid)
          if (addIndex >= 0) {
            this.form.addedSubsidiaryCompanyKeys.splice(index, 1)
          }
        }
      }).catch(() => { })
    },
    getSubmitData() {
      return {
        company: this.form
      }
    },
    addSubsidiaryCompany(rows) {
      for (const row of rows) {
        const index = this.rowData.findIndex(p => p.uuid === row.uuid)
        if (index < 0) {
          this.rowData.push(row)
        }
        const addIndex = this.form.addedSubsidiaryCompanyKeys.findIndex(p => p === row.uuid)
        if (addIndex < 0) {
          this.form.addedSubsidiaryCompanyKeys.push(row.uuid)
        }
        const delIndex = this.form.deletedSubsidiaryCompanyKeys.findIndex(p => p === row.uuid)
        if (delIndex >= 0) {
          this.form.deletedSubsidiaryCompanyKeys.splice(index, 1)
        }
      }
      this.queryCompanyDialog.visible = false
    },
    companyTypeLabelFunc(company) {
      let text = ''
      const mapping = PartnerServiceItem.PARTNER_SERVICE_ITEM_MAPPING
      for (const item of mapping) {
        if (company[item.key]) {
          const name = this.isZh ? item.value.chineseName : item.value.englishName
          if (text) {
            text = text + ',' + name
          } else {
            text = name
          }
        }
      }
      return text
    }
  }
}
</script>

<style scoped lang="scss">
  .subsidiaryInformation-form {
    &.section {
      padding: 10px 20px 20px 20px;
    }
    .el-select {
      width: 100%;
    }
    .no-pointer ::v-deep {
      .el-checkbox__input {
        cursor: default;
      }
    }
  }
</style>
